/** Role gate (docs/06 §1): a `member` — or an account with no role yet — gets no console. */
import { useAuth } from '../auth/AuthProvider';
import { Button } from '../components/ui/button';
import { useT } from '../i18n';

export function NoAccess({ supportEmail }: { supportEmail?: string }) {
  const { t } = useT();
  const { account, me, signOut } = useAuth();
  const email = me?.email ?? account?.email ?? '';

  return (
    <main className="flex min-h-dvh items-center justify-center bg-canvas p-6">
      <div className="w-full max-w-[420px] rounded-[14px] border border-line bg-panel p-6 text-center">
        <span aria-hidden="true" className="mx-auto block size-6 rounded-full bg-pink" />
        <h1 className="mt-4 text-[22px] font-bold text-ink">{t('cms:noAccess.title')}</h1>
        <p className="mt-2 text-[13px] text-muted">{t('cms:login.noAccess')}</p>
        {email && (
          <p className="mt-3 text-[12px] text-muted">{t('cms:noAccess.signedInAs', { email })}</p>
        )}
        {supportEmail && (
          <p className="mt-1 text-[12px] text-muted">
            {t('common:auth.help', { email: supportEmail })}
          </p>
        )}
        <Button variant="secondary" className="mt-5 w-full" onClick={() => void signOut()}>
          {t('common:actions.logout')}
        </Button>
      </div>
    </main>
  );
}
